import React from 'react';
import Funciones from './Funciones';
import App from '../App';
import CONST from '../config/configFeria.json'
import logo from './logohola.png'
import { Link } from 'react-router-dom';
class Lista extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            archivos: [],
            publicUrl: "",
            data: [],
        };

        this.state.publicUrl = props.publicUrl;
    }

    //Función que llama a la función php que obtiene la lista de ficheros
    async componentDidMount() {

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/config-planner`);
        const data = await response.json();
        const fairs = data.map(item => item.fair)
        /* const respuesta = ["fitur-2023.txt"]
        const archivos = respuesta; */
        // const respuesta = await fetch(process.env.REACT_APP_URL_ACTIONS+'obtener.php');
        // const archivos = await respuesta.json();

        this.setState({
            archivos: fairs,
            data,
        });
    }

    render(){
        //Se construye la tabla que muestra la lista de ficheros
        return(
        <div>
            <div className="kt-portlet__head-label">
            <img src={logo} alt="Aplicacion de Ferias"/>
            
            <h3 className="kt-portlet__head-title">Aplicación Ferias </h3>
            </div>
            <table className="table is-fullwidth is-bordered">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                    {this.state.archivos.map(arch => {
                        return <Funciones key={arch} arch={arch} publicUrl={this.state.publicUrl} fairs={this.state.archivos} fairsData={this.state.data}></Funciones>;
                    })}
              </tbody>
              </table>
        </div>
            );
    }
}
export default Lista;
